<style scoped>
.header {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 88px;
  opacity: 1;
  display: flex;
  background: rgba(23, 43, 47, 0.4);
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(120, 120, 120, 0.4);
  z-index: 999;
  padding: 0px 360px;
}
.header1 {
  width: 1200px;
  height: 88px;
  display: flex;
  margin: 0 auto;
}
.header2 {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 88px;
  opacity: 1;
  display: flex;
  box-sizing: border-box;
  border-width: 0px 0px 1px 0px;
  border-style: solid;
  border-color: rgba(120, 120, 120, 0.4);
  z-index: 999;
  background: rgba(23, 43, 47, 0.4);
  padding: 0px 250px;
}
.logo_image {
  width: 145px;
  height: 44px;
  margin: 22px 108px 22px 0px;
}
.tabs {
  display: flex;
  height: 88px;
  line-height: 88px;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  flex: 1;
  font-variation-settings: "opsz" auto;
  /* color-white */
  color: #ffffff;
}
.pr50 {
  padding-right: 50px;
}
.ziyuan {
  cursor: pointer;
}
.login {
  display: flex;
}
.login-button {
  width: 100px;
  height: 40px;
  background: #227110;
  margin-top: 24px;
  color: #ffffff;
  border-radius: 20px;
  font-family: PingFang SC;
}
.carousel {
  height: 1080px;
}
.el-carousel {
  height: 1080px;
  text-align: center;
}
.support-footer >>> .el-carousel {
  height: 79px;
  width: 1200px;
  overflow: hidden;
}
.scheme {
  position: relative;
  height: 1125px;
  background: #f5f7f9;
  margin-top: -10px;
}
.scheme-header {
  width: 100%;
  font-family: Source Han Sans;
  font-size: 64px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  padding: 110px 0px 24px 0px;
  background: #f5f7f9;
}
.scheme-header-subtitle {
  width: 100%;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  background: #f5f7f9;
}
.scheme-tabs {
  /* width: 615px; */
  width: 416px;
  height: 60px;
  border-radius: 30px;
  opacity: 1;

  /* 自动布局 */
  display: flex;
  flex-direction: undefined;
  justify-content: undefined;
  align-items: undefined;
  padding: NaNpx;

  background: #ffffff;
  margin: 60px auto 69px;
}
.scheme-tabs2 {
  width: 615px;
  height: 60px;
  opacity: 1;

  /* 自动布局 */
  display: flex;

  margin: 60px auto 69px;
}
.scheme-tab-item {
  flex: 1;
  text-align: center;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 8px 0px;
  cursor: pointer;
}
.scheme-tab-item-active {
  color: #fff;
  background-image: url("../assets/bg1.png");
  background-size: cover;
}
.scheme-tab-contents {
  display: flex;
  width: 1183px;
  height: 555px;
  margin: 0 auto;
}
.scheme-tab-contents2 {
  display: flex;
  width: 1183px;
  height: 555px;
  margin: 0 auto;
}
.tab-contents-item {
  position: relative;
  /* width: 373px !important; */
  width: 389px !important;
  /* height: 531px !important; */
  background: #ffffff;
  border-radius: 24px;
  cursor: pointer;
  opacity: 1;
}
.tab-contents-item-active {
  opacity: 1;
  width: 389px;
  height: 587px !important;
  color: #fff;
  /* background: linear-gradient(195deg, #42a421 2%, #2e7516 90%) !important; */
  background: -webkit-linear-gradient(195deg, #42a421 2%, #2e7516 90%),
    linear-gradient(195deg, #42a421 2%, #2e7516 90%);
  background-image: -webkit-linear-gradient(195deg, #42a421 2%, #2e7516 90%),
    linear-gradient(195deg, #42a421 2%, #2e7516 90%); /* 确保兼容老旧系统 */
  margin-top: -20px !important;
}
.mlr32 {
  margin: 0px 32px;
}
.bgr {
  background: red;
}
.bgo {
  background: orange;
}
.bgg {
  background: green;
}
.tab-contents-item-text1 {
  font-family: Source Han Sans;
  font-size: 24px;
  font-weight: 500;
  text-align: left;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 40px 0px 16px 40px;
}
.tab-contents-item-text2 {
  margin: 0px 0px 24px 40px;
}
.tab-contents-item-text2-left {
  font-family: Montserrat;
  font-size: 54px;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  /* 主色 */
  color: #2e7516;
}
.tab-contents-item-text2-right {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  padding-left: 16px;
}
.line1 {
  width: 293px;
  height: 0px;
  border-top: 1px solid #d8d8d8;
  margin: 24px auto;
}
.moneny {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 600;
  font-size: 36px;
  color: #2e7516;
}
.crp {
  cursor: pointer;
}
.df {
  display: flex;
}
.text1 {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 8px 25px 0px 40px;
}
.text2 {
  min-width: 197px;
  height: 40px;
  line-height: 40px;
  opacity: 1;

  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  background: #f5f7f9;
  border-radius: 8px;
  margin-right: 40px;
}
.text2-en {
  font-size: 12px;
}
.text3 {
  margin: 16px 0px 0px 40px;
}
.gou-img {
  width: 24px;
  height: 24px;
  margin-right: 16px;
}
.gou-text {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.text3-button {
  width: 293px;
  height: 54px;
  border-radius: 27px;
  opacity: 1;

  /* 主色 */
  background: #2e7516;
  margin: 10px auto 0px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 54px;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
.text3-button-active {
  background: #fff;
  color: #2e7516;
}
.mb39 {
  margin-bottom: 39px;
}
.poa40 {
  position: absolute;
  left: 40px;
  bottom: 16px;
}
.fanyi-function {
  background: #ffffff;
}
.fanyi-function-title {
  min-width: 816px;
  max-width: 1200px;
  font-family: Source Han Sans;
  font-size: 48px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 110px auto 32px;
}
.fanyi-function-subtitle {
  min-width: 567px;
  max-width: 1200px;
  margin: 0px auto 60px;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #757575;
}
.fanyi-function-tabs {
  display: flex;
  /* width: 749px; */
  width: 526px;
  margin: 0px auto 60px;
}
.fanyi-function-tab-item {
  width: 223px;
  height: 60px;
  border-radius: 30px;
  background: #f5f7f9;
  line-height: 60px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.fanyi-function-tab-item-active {
  color: #fff;
  background: #2e7516;
}
.fanyi-function-tab-img {
  width: 1197px;
  height: 598px;
  margin: 0 auto 180px;
  background-image: url("../assets/beiji3.png");
  background-size: cover;
  text-align: center;
}
.fanyi_image {
  width: 1009px;
  margin: 56px auto 0px;
}
.fanyi-function-imgs {
  display: flex;
  width: 1200px;
  height: 456px;
  margin: 0 auto 180px;
}
.fanyi-function-img-item {
  width: 360px;
  cursor: pointer;
  border-radius: 24px;
}
.fanyi-function-img-item:hover {
  box-shadow: 0px 0px 39px 0px rgba(34, 113, 16, 0.3);
  border-radius: 24px;
}
.intelligent-agent {
  width: 100%;
  background: #f5f7f9;
}
.intelligent-agent-content {
  display: flex;
  width: 1199px;
  height: 869px;
  margin: 0 auto;
}
.intelligent-agent-content-left {
  width: 525px;
  margin-right: 116px;
}
.intelligent-agent-content-right {
  width: 558px;
  height: 588px;
  background-image: url("../assets/intelligent-right-img.png");
  background-size: cover;
  margin-top: 122px;
  border-radius: 15px;
}
.intelligent-agent-content-right-en {
  width: 558px;
  height: 588px;
  background-image: url("../assets/intelligent-right-img-en.png");
  background-size: cover;
  margin-top: 122px;
  border-radius: 15px;
}
.mlf40 {
  margin: 0px 40px;
}
.mlr60 {
  margin: 0px 60px;
}
.text5 {
  font-family: Source Han Sans;
  font-size: 40px;
  font-weight: bold;
  line-height: 72px;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 182px 0px 24px 0px;
}
.text6 {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #787878;
  margin-bottom: 38px;
}
.intelligent-text1 {
  display: flex;
  width: 154px;
  height: 59px;
  line-height: 59px;
  border-radius: 16px;
  background: #ffffff;
  margin-right: 24px;
}
.icon-img {
  width: 24px;
  height: 24px;
  margin: 18px 16px 0px 16px;
}
.icon-text {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 主色 */
  color: #2e7516;
}
.intelligent-button {
  display: flex;
  width: 176px;
  height: 68px;
  border-radius: 35px;
  opacity: 1;
  margin-top: 102px;
  background-image: url("../assets/intelligent-button.png");
  background-size: cover;
  cursor: pointer;
}
.support {
  height: 869px;
}
.support-content {
  width: 1199px;
  height: 869px;
  margin: 0 auto;
}
.support-content-title {
  min-width: 336px;
  font-family: Source Han Sans;
  font-size: 48px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin: 120px auto 78px;
}
.support-contents {
  display: flex;
  width: 1200px;
  height: 305px;
  margin: 0 auto;
}
.support-content-item {
  width: 360px;
  height: 305px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
}
.icon3-img {
  width: 68px;
  height: 68px;
  margin: 24px;
}
.icon3-text {
  font-family: Source Han Sans;
  font-size: 30px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
  margin-top: 32px;
}
.icon3-text-en {
  font-size: 24px;
  text-align: left;
}
.text7 {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  margin: 8px 24px 0px 24px;
}
.text7-en {
  font-size: 14px;
}
.support-footer {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  width: 1200px;
  height: 79px;
  margin: 250px auto 0px;
}
.support-footer-front {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 130px;
  height: 150px;
  z-index: 999;
}
.support-footer-after {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 130px;
  height: 150px;
  z-index: 999;
}
.support-footer-img0 {
  width: 160px;
  height: 50px;
  margin-right: 24px;
  margin-top: 7px;
}
.support-footer-img-yandex {
  width: 134px;
  height: 55px;
  margin-right: 24px;
}
.support-footer-img-huoshan {
  width: 194px;
  height: 36px;
  margin-top: 14px;
  margin-right: 24px;
}
.support-footer-img1 {
  width: 165px;
  height: 59px;
  margin-right: 24px;
}
.support-footer-img2 {
  width: 180px;
  height: 63px;
  margin-right: 24px;
}
.support-footer-img3 {
  width: 207px;
  height: 52px;
  margin-right: 24px;
  margin-top: 8px;
}
.support-footer-img4 {
  width: 222px;
  height: 79px;
  margin-right: 24px;
}
.support-footer-img5 {
  width: 222px;
  height: 74px;
  margin-right: 24px;
  /* margin-right: -110px; */
}
.footer {
  width: 100%;
  /* height: 782px;  */
  height: 520px;
  background-image: url("../assets/footer-bg.png");
  background-size: cover;
  padding-top: 60px;
}
.footer-content {
  width: 1199px;
  margin: 0 auto;
}
.footer_image {
  width: 100%;
  height: 100%;
}
.footer-pop {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 249px;
  height: 60px;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 60px;
  text-align: center;
  letter-spacing: 0em;
  color: #ffffff;
}
.footer-title {
  position: relative;
  width: 1200px;
  height: 262px;
  margin: 0 auto;
  background-image: url("../assets/footer-bg2.png");
  background-size: cover;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: 300px;
  margin: 80px auto 0px;
}
.footer-bottom-left {
  flex: 1;
}
.footer-bottom-right {
  display: flex;
  flex: 1;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  cursor: pointer;
  margin: 90px 0px 0px 220px;
  text-align: center;
}
.tab-active {
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
  text-align: center;
}
.tab-active-text {
  border-bottom: 3px solid #227110;
  padding-bottom: 6px;
  color: #2e7516;
}
.resources {
  position: fixed;
  display: flex;
  height: 96px;
  top: 104px;
  left: 470px;
  z-index: 9999;
}
.resources-content {
  display: flex;
  width: 980px;
  margin: 0 auto;
  border-radius: 24px;
  background: #ffffff;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
}
.resources-content-item {
  width: 284px;
  height: 66px;
  margin: 15px 0px 15px 24px;
  padding: 10px 0px 0px 24px;
  box-sizing: border-box;
  cursor: pointer;
}
.resources-content-item-text1 {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
}
.resources-content-item-text2 {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
}
.resources-content-item-active {
  border-radius: 16px;
  background: #fafafa;
}
.freeTrialImg {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 70%;
  left: 50%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  /* cursor: pointer;  */
  background-image: url("../assets/free-trial-button.png");
  background-size: cover;
}
.freeTrialEnImg {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 70%;
  left: 50%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  /* cursor: pointer;  */
  background-image: url("../assets/free-trial-button-en.png");
  background-size: cover;
}
.freeTrialImg:hover {
  background-image: url("../assets/free-trial-button-hover.png");
  background-size: cover;
}
.freeTrialEnImg:hover {
  background-image: url("../assets/free-trial-button-hover-en.png");
  background-size: cover;
}
.freeTrialImg2 {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 74%;
  left: 23%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  /* cursor: pointer;  */
  background-image: url("../assets/free-trial-button2.png");
  background-size: cover;
}
.freeTrialEnImg2 {
  width: 176px;
  height: 68px;
  position: absolute;
  z-index: 99999;
  top: 80%;
  left: 23%;
  transition: transform 0.3s ease;
  transform: translate(-50%, -50%); /* 同时水平和垂直居中 */
  /* cursor: pointer;  */
  background-image: url("../assets/free-trial-button2-en.png");
  background-size: cover;
}
.freeTrialImg2:hover {
  background-image: url("../assets/free-trial-button-hover2.png");
  background-size: cover;
}
.freeTrialEnImg2:hover {
  background-image: url("../assets/free-trial-button-hover2-en.png");
  background-size: cover;
}
.consult {
  position: fixed;
  top: 650px;
  right: 16px;
  z-index: 999;
}
.scan {
  position: fixed;
  right: 80px;
  top: 520px;
  z-index: 9999;
  width: 194px;
  height: 224px;
  border-radius: 16px;
  box-shadow: 0px 3.19px 27.93px 0px rgba(156, 156, 156, 0.3);
}
.scan >>> .el-image {
  width: 202.65px;
  height: 224px;
}

.scan-text1 {
  text-align: center;
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.scan-text2 {
  text-align: center;
  font-family: Source Han Sans;
  font-size: 11.17px;
  font-weight: 500;
  line-height: 15.96px;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #3d3d3d;
}
.tel {
  position: fixed;
  top: 750px;
  right: 80px;
  z-index: 9999;
  width: 194px;
  height: 224px;
  border-radius: 16px;
  box-shadow: 0px 3.19px 27.93px 0px rgba(156, 156, 156, 0.3);
}
.tel >>> .el-image {
  width: 202.65px;
  height: 224px;
}
.consult-item1 {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item1-en {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3en.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item1-tw {
  width: 40px;
  height: 92px;
  border-radius: 24px;
  margin-bottom: 16px;
  background-image: url("../assets/consult3tw.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2 {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2-en {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4en.png");
  background-size: cover;
  cursor: pointer;
}
.consult-item2-tw {
  width: 40px;
  height: 88px;
  border-radius: 24px;
  box-sizing: border-box;
  border: 1px solid #227110;
  background-image: url("../assets/consult4tw.png");
  background-size: cover;
  cursor: pointer;
}
.white {
  color: #fff;
}
.names {
  width: 272px;
  margin-right: 40px;
  border-radius: 22.5px;
}
.phone {
  min-width: 272px;
}
.phone >>> .el-input__inner {
  border-radius: 0px 22.5px 22.5px 0px;
  border-left: none;
}
.phone >>> .el-select {
  width: 70px;
  border-radius: 22.5px 0px 0px 22.5px;
  border-right: none;
  color: #172b2f;
}
.phone >>> .el-select .el-input .el-select__caret {
  color: #172b2f;
}
.phone >>> .el-input-group__prepend {
  background: rgba(23, 43, 47, 0.15);
  border-radius: 22.5px 0px 0px 22.5px;
  border-right: none;
}
::v-deep .el-input__inner {
  border-radius: 22.5px;
  background: rgba(23, 43, 47, 0.15);
  color: #9f9f9f;
}
::v-deep .el-input__inner::placeholder {
  color: #9f9f9f;
}
.reservation {
  width: 190px;
  height: 48px;
  line-height: 48px;
  border-radius: 27px;
  background: rgba(46, 117, 22, 0.5);
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* color-white */
  color: #ffffff;
  margin: 40px auto 0px;
  cursor: pointer;
}
.scale {
  transform: scale(1.1); /* 放大10% */
}
.footer_logo_image {
  width: 224px;
  height: 68px;
  margin-bottom: 22px;
}
.footer_logo_text {
  font-family: Source Han Sans;
  font-size: 18px;
  font-weight: normal;
  line-height: 40px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #ffffff;
}
.beian {
  width: 100%;
  height: 90px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: 90px;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #787878;
  border-top: 1px solid #2a494f;
  margin-top: 48px;
}
.lang {
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  text-align: center;
  border: 2px solid #fff;
  font-size: 16px;
  color: #fff;
  margin: 29px 38px 0px 24px;
  cursor: pointer;
  box-sizing: border-box;
}
.appDown {
  margin-top: 30px;
  color: #fff;
  cursor: pointer;
  min-width: 36px;
  height: 30px;
  line-height: 30px;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
}
.langs2 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 440px;
  width: 152px;
  height: 124px;
  z-index: 9999;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.langs {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 500px;
  width: 152px;
  height: 124px;
  z-index: 9999;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.lang-en2 {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 440px;
  min-width: 152px;
  height: 124px;
  z-index: 9999;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.lang-en {
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  top: 90px;
  right: 500px;
  min-width: 152px;
  height: 124px;
  z-index: 9999;
  background: #ffffff;
  border-radius: 24px;
  text-align: center;
  font-family: Source Han Sans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #172b2f;
  cursor: pointer;
}
.lang-active {
  color: #2e7516;
  font-weight: 500;
}
.person_logo_image {
  width: 40px;
  height: 40px;
  margin: 25px 10px 0px 0px;
  cursor: pointer;
}
.phone1 {
  font-size: 14px;
  color: #fff;
  padding: 34px 10px 0px 0px;
  cursor: pointer;
}
.console-panel {
  position: fixed;
  width: 208px;
  height: 135.5px;
  top: 44px;
  /* right: 300px; */
  right: 300px;
  z-index: 9999;
  background-image: url("../assets/console-panel-bg.png");
  background-size: cover;
  box-sizing: border-box;
  padding-top: 44px;
}
.console-panel-en {
  position: fixed;
  width: 208px;
  height: 135.5px;
  top: 44px;
  /* right: 300px; */
  right: 200px;
  z-index: 9999;
  background-image: url("../assets/console-panel-bg.png");
  background-size: cover;
  box-sizing: border-box;
  padding-top: 44px;
}
.console-panel-text1 {
  width: 124px;
  height: 40px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #2e7516;
  padding: 10px 0px 10px 24px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 auto;
}
.console-panel-active {
  background: #fafafa;
  border-radius: 8px;
}
.console-panel-text2 {
  width: 124px;
  height: 40px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #9f9f9f;
  padding: 10px 0px 10px 24px;
  box-sizing: border-box;
  cursor: pointer;
  margin: 0 auto;
  border-radius: 8px;
}
.wh100 {
  width: 100%;
  height: 100%;
}
.tabItem1 {
  min-width: 36px;
}
.tabItem2 {
  min-width: 72px;
}
a {
  text-decoration: none;
}
.m16 {
  margin: 0px 16px;
}
.cur {
  cursor: pointer;
}
.appDownImg {
  width: 112px;
  height: 40px;
  cursor: pointer;
  margin-top: 24px;
  box-sizing: border-box;
}
.appDownImg2 {
  width: 164px;
  height: 40px;
  cursor: pointer;
  margin-top: 24px;
  box-sizing: border-box;
}
.originalPrice {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  text-align: left;
  letter-spacing: 0em;
  text-decoration: line-through;
  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  color: #9f9f9f;
  padding: 0px 0px 24px 40px;
}
.originalPrice-active {
  color: #fff;
}
.carousel-flex {
  display: flex;
  padding-top: 16px;
}
/* style-end */
</style>
<template>
  <div id="app">
    <div
      :class="{
        header: $i18n.locale === 'cn' || $i18n.locale === 'tw',
        header2: $i18n.locale === 'en',
      }"
    >
      <div class="logo">
        <el-image class="logo_image" :src="logo" fit="fill" />
      </div>
      <div class="tabs">
        <div class="pr50 crp tabItem1" @click="handleTabs(1)">
          <span :class="{ 'tab-active-text': tabIndex === 1 }">{{
            $t("HomePage.headerText1")
          }}</span>
        </div>
        <div class="pr50 crp tabItem2" @click="handleTabs(2)">
          <span :class="{ 'tab-active-text': tabIndex === 2 }">{{
            $t("HomePage.headerText2")
          }}</span>
        </div>
        <div class="pr50 crp" @click="handleTabs(3)">
          <span :class="{ 'tab-active-text': tabIndex === 3 }">{{
            $t("HomePage.headerText3")
          }}</span>
        </div>
        <!-- <div class="pr50 crp" @click="handleTabs(4)">
          <span :class="{ 'tab-active-text': tabIndex === 4 }">{{$t("HomePage.headerText4")}}</span>
        </div> -->
        <div>
          <span
            :class="{
              'el-dropdown-link': true,
              ziyuan: true,
              crp: true,
              'tab-active-text': tabIndex === 5,
            }"
            @click="handleTabs(5)"
          >
            {{ $t("HomePage.headerText5")
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
        </div>
      </div>
      <div class="login" v-if="!isLogin">
        <div class="lang" @click="handleLangs">{{ langName }}</div>
        <el-button class="login-button" @click="toLogin">{{
          $t("HomePage.buttonText1")
        }}</el-button>
      </div>
      <div class="login" v-else>
        <div class="lang" @click="handleLangs">{{ langName }}</div>
        <div @click="handleConsole()">
          <el-image class="person_logo_image" :src="personLogoImg" fit="fill" />
        </div>
        <div class="phone1" @click="handleConsole()">
          <span
            :class="{
              'el-dropdown-link': true,
              ziyuan: true,
              crp: true,
            }"
          >
            {{ account
            }}<i class="el-icon-arrow-down el-icon--right" v-if="account"></i>
          </span>
        </div>
      </div>
    </div>
    <div
      :class="{
        langs: $i18n.locale === 'cn' || $i18n.locale === 'tw',
        'lang-en': $i18n.locale === 'en',
      }"
      v-if="showLangs && isLogin"
    >
      <div
        :class="{ 'lang-active': langIndex === 1 }"
        @click="handleLangItem(1)"
      >
        {{ $t("HomePage.langText1") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 2 }"
        @click="handleLangItem(2)"
      >
        {{ $t("HomePage.langText2") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 3 }"
        @click="handleLangItem(3)"
      >
        {{ $t("HomePage.langText3") }}
      </div>
    </div>
    <div
      :class="{
        langs2: $i18n.locale === 'cn' || $i18n.locale === 'tw',
        'lang-en2': $i18n.locale === 'en',
      }"
      v-if="showLangs && !isLogin"
    >
      <div
        :class="{ 'lang-active': langIndex === 1 }"
        @click="handleLangItem(1)"
      >
        {{ $t("HomePage.langText1") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 2 }"
        @click="handleLangItem(2)"
      >
        {{ $t("HomePage.langText2") }}
      </div>
      <div
        :class="{ 'lang-active': langIndex === 3 }"
        @click="handleLangItem(3)"
      >
        {{ $t("HomePage.langText3") }}
      </div>
    </div>
    <div class="resources" v-if="tabIndex === 5 && showResources">
      <div class="resources-content">
        <!-- API文档 -->
        <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 1,
          }"
          @click="handleTabs2(1)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources1") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources2") }}
          </div>
        </div>
        <!-- 常见问题 -->
        <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 2,
          }"
          @click="handleTabs2(2)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources3") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources4") }}
          </div>
        </div>
        <!-- 联系我们 -->
        <!-- <div
          :class="{
            'resources-content-item': true,
            'resources-content-item-active': tabIndex2 === 3,
          }"
          @click="handleTabs2(3)"
        >
          <div class="resources-content-item-text1">
            {{ $t("HomePage.resources5") }}
          </div>
          <div class="resources-content-item-text2">
            {{ $t("HomePage.resources6") }}
          </div>
        </div> -->
      </div>
    </div>
    <div
      :class="{
        'console-panel': true,
        'console-panel-en': $i18n.locale === 'en',
      }"
      v-if="showConsole"
    >
      <div
        :class="{
          'console-panel-text1': true,
          'console-panel-active': consoleIndex === 1,
        }"
        @click="handleConsoleItem(1)"
      >
        {{ $t("TextTranslation.text1") }}
      </div>
      <div
        :class="{
          'console-panel-text2': true,
          'console-panel-active': consoleIndex === 2,
        }"
        @click="handleConsoleItem(2)"
      >
        {{ $t("TextTranslation.text2") }}
      </div>
    </div>
    <div class="carousel">
      <el-carousel
        trigger="click"
        arrow="hover"
        height="100%"
        @change="handleCarousel"
      >
        <el-carousel-item v-for="item in imgs" :key="item.value">
          <div class="wh100">
            <el-image :src="item.imgSrc" fit="contain" />
          </div>
        </el-carousel-item>
      </el-carousel>
      <div
        class="freeTrialImg"
        v-if="tabIndex3 === 0 && langName === 'ZH'"
        @click="handleFreeTrial"
      ></div>
      <div
        class="freeTrialEnImg"
        v-if="tabIndex3 === 0 && langName === 'EN'"
        @click="handleFreeTrial"
      ></div>
      <div
        class="freeTrialEnImg"
        v-if="tabIndex3 === 0 && langName === 'TW'"
        @click="handleFreeTrial"
      ></div>
      <div
        class="freeTrialImg2"
        v-if="tabIndex3 === 1 && langName === 'ZH'"
        @click="handleFreeTrial"
      ></div>
      <div
        class="freeTrialEnImg2"
        v-if="tabIndex3 === 1 && langName === 'EN'"
        @click="handleFreeTrial"
      ></div>
      <div
        class="freeTrialEnImg2"
        v-if="tabIndex3 === 1 && langName === 'TW'"
        @click="handleFreeTrial"
      ></div>
    </div>
    <div class="scheme">
      <div class="scheme-header">{{ $t("HomePage.scheme1") }}</div>
      <div class="scheme-header-subtitle">
        {{ $t("HomePage.scheme2") }}
      </div>
      <!-- <div class="scheme-tabs2"></div> -->
      <div class="scheme-tabs">
        <div
          :class="{
            'scheme-tab-item': true,
            'scheme-tab-item-active': tabIndex4 === 1,
          }"
          @click="handleSchemeTab(1)"
        >
          {{ $t("HomePage.scheme3") }}
        </div>
        <div
          :class="{
            'scheme-tab-item': true,
            'scheme-tab-item-active': tabIndex4 === 2,
          }"
          @click="handleSchemeTab(2)"
        >
          {{ $t("HomePage.scheme4") }}
        </div>
        <!-- <div
          :class="{
            'scheme-tab-item': true,
            'scheme-tab-item-active': tabIndex4 === 3,
          }"
          @click="handleSchemeTab(3)"
        >
          {{$t("HomePage.scheme5")}}
        </div> -->
      </div>
      <div class="scheme-tab-contents" v-if="tabIndex4 === 1">
        <div
          :class="{
            'tab-contents-item': true,
            'tab-contents-item-active': tabIndex4 === 1 && tabIndex6 === 1,
          }"
          @click="handleSchemeTabItem(1)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 1 && tabIndex6 === 1,
            }"
          >
            <!-- 基础版 -->
            {{ $t("HomePage.scheme6") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.economy?.currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
              >{{ textPrices?.economy?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme7")
            }}</span>
          </div>
          <!-- 文本翻译基础版原价 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 1 && tabIndex6 === 1,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
              >¥</span
            >
            <!-- 原价：¥50 -->
            <span
              :class="{
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
              >{{ textPrices?.economy?.originalPrice }}</span
            >
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme9") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
            >
              {{ $t("HomePage.scheme10") }}
            </div>
          </div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
            >
              {{ $t("HomePage.scheme11") }}
            </div>
          </div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
            >
              {{ $t("HomePage.scheme12") }}
            </div>
          </div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 1,
              }"
            >
              {{ $t("HomePage.scheme13") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 1 && tabIndex6 === 1,
            }"
            @click="toConsolePage(1)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
        <div
          :class="{
            'tab-contents-item': true,
            mlr32: true,
            'tab-contents-item-active': tabIndex4 === 1 && tabIndex6 === 2,
          }"
          @click="handleSchemeTabItem(2)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 1 && tabIndex6 === 2,
            }"
          >
            {{ $t("HomePage.scheme15") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.economy?.currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
              >{{ textPrices?.premium?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme7")
            }}</span>
          </div>
          <!-- 文本翻译-高级版原价 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 1 && tabIndex6 === 2,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
              >$</span
            >
            <!-- 原价：¥120 -->
            {{ textPrices?.premium?.originalPrice }}
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme9") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 2"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 2"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
            >
              {{ $t("HomePage.scheme16") }}
            </div>
          </div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 2"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 2"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
            >
              {{ $t("HomePage.scheme20") }}
            </div>
          </div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 2"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 2"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 2,
              }"
            >
              {{ $t("HomePage.scheme18") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 1 && tabIndex6 === 2,
            }"
            @click="toConsolePage(1)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
        <div
          :class="{
            'tab-contents-item': true,
            'tab-contents-item-active': tabIndex4 === 1 && tabIndex6 === 3,
          }"
          @click="handleSchemeTabItem(3)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 1 && tabIndex6 === 3,
            }"
          >
            {{ $t("HomePage.scheme19") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.economy?.currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 3,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 1 && tabIndex6 === 3,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 1 && tabIndex6 === 3,
              }"
              >{{ textPrices?.standard?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme7")
            }}</span>
          </div>
          <!-- 文本翻译-标准版原价 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 1 && tabIndex6 === 3,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 1 && tabIndex6 === 3,
              }"
              >$</span
            >
            <!-- 原价：¥100 -->
            {{ textPrices?.standard?.originalPrice }}
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 1 && tabIndex6 === 3,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme9") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 1 && tabIndex6 === 3"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 1 && tabIndex6 === 3"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 1 && tabIndex6 === 3,
              }"
            >
              {{ $t("HomePage.scheme17") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 1 && tabIndex6 === 3,
            }"
            @click="toConsolePage(1)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
      </div>
      <div class="scheme-tab-contents" v-if="tabIndex4 === 2">
        <div
          :class="{
            'tab-contents-item': true,
            'tab-contents-item-active': tabIndex4 === 2 && tabIndex7 === 1,
          }"
          @click="handleSchemeTabItem2(1)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 2 && tabIndex7 === 1,
            }"
          >
            <!-- 语音转文字识别 -->
            {{ $t("HomePage.scheme21") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.voice[0].currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
              >{{ textPrices?.voice[0]?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme22")
            }}</span>
          </div>
          <!-- 语音翻译-语音转文字识别原价 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 2 && tabIndex7 === 1,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
              >$</span
            >
            <!-- 原价：¥50 -->
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
              >{{ textPrices?.voice[0]?.originalPrice }}</span
            >
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 2 && tabIndex7 === 1,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme23") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 2 && tabIndex7 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 2 && tabIndex7 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 2 && tabIndex7 === 1,
              }"
            >
              {{ $t("HomePage.scheme18") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 2 && tabIndex7 === 1,
            }"
            @click="toConsolePage(2)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
        <div
          :class="{
            'tab-contents-item': true,
            mlr32: true,
            'tab-contents-item-active': tabIndex4 === 2 && tabIndex7 === 2,
          }"
          @click="handleSchemeTabItem2(2)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 2 && tabIndex7 === 2,
            }"
          >
            <!-- 指定语言语音翻译 -->
            {{ $t("HomePage.scheme24") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.voice[1].currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
              >{{ textPrices?.voice[1]?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme22")
            }}</span>
          </div>
          <!-- 语音翻译-指定语言语音翻译原价 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 2 && tabIndex7 === 2,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
              >$</span
            >
            <!-- 原价：¥50 -->
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
              >{{ textPrices?.voice[1]?.originalPrice }}</span
            >
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 2 && tabIndex7 === 2,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme23") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 2 && tabIndex7 === 2"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 2 && tabIndex7 === 2"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 2 && tabIndex7 === 2,
              }"
            >
              {{ $t("HomePage.scheme18") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 2 && tabIndex7 === 2,
            }"
            @click="toConsolePage(2)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
        <div
          :class="{
            'tab-contents-item': true,
            mlr32: true,
            'tab-contents-item-active': tabIndex4 === 2 && tabIndex7 === 3,
          }"
          @click="handleSchemeTabItem2(3)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 2 && tabIndex7 === 3,
            }"
          >
            <!-- 自动识别语言语音翻译 -->
            {{ $t("HomePage.scheme25") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              v-if="textPrices?.voice[2].currency === 'CNY'"
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
              >¥</span
            >
            <span
              v-else
              :class="{
                moneny: true,
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
              >$</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
              >{{ textPrices?.voice[2]?.price }}</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme22")
            }}</span>
          </div>
          <!-- 语音翻译-自动识别语言语音翻译 -->
          <div
            :class="{
              originalPrice: true,
              'originalPrice-active': tabIndex4 === 2 && tabIndex7 === 3,
            }"
          >
            {{ $t("HomePage.text7") }}
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
              >$</span
            >
            <!-- 原价：¥50 -->
            <span
              :class="{
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
              >{{ textPrices?.voice[2]?.originalPrice }}</span
            >
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 2 && tabIndex7 === 3,
                'text2-en': langName === 'EN',
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div :class="{ text2: true, 'text2-en': langName === 'EN' }">
              {{ $t("HomePage.scheme23") }}
            </div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 2 && tabIndex7 === 3"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 2 && tabIndex7 === 3"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 2 && tabIndex7 === 3,
              }"
            >
              {{ $t("HomePage.scheme18") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 2 && tabIndex7 === 3,
            }"
            @click="toConsolePage(2)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
      </div>
      <div class="scheme-tab-contents" v-if="tabIndex4 === 3">
        <div
          :class="{
            'tab-contents-item': true,
            'tab-contents-item-active': tabIndex4 === 3 && tabIndex8 === 1,
          }"
          style="margin-left: 405px"
          @click="handleSchemeTabItem3(1)"
        >
          <div
            :class="{
              'tab-contents-item-text1': true,
              white: tabIndex4 === 3 && tabIndex8 === 1,
            }"
          >
            {{ $t("HomePage.scheme5") }}
          </div>
          <div class="tab-contents-item-text2">
            <span
              :class="{
                moneny: true,
                white: tabIndex4 === 3 && tabIndex8 === 1,
              }"
              >¥</span
            >
            <span
              :class="{
                'tab-contents-item-text2-left': true,
                white: tabIndex4 === 3 && tabIndex8 === 1,
              }"
              >90</span
            >
            <span class="tab-contents-item-text2-right">{{
              $t("HomePage.scheme7")
            }}</span>
          </div>
          <div class="df">
            <div
              :class="{
                text1: true,
                white: tabIndex4 === 3 && tabIndex8 === 1,
              }"
            >
              {{ $t("HomePage.scheme8") }}
            </div>
            <div class="text2">5</div>
          </div>
          <div class="line1"></div>
          <div class="df text3">
            <div>
              <el-image
                class="gou-img"
                :src="gouImg"
                fit="fill"
                v-if="tabIndex4 !== 3 && tabIndex8 === 1"
              />
              <el-image
                class="gou-img"
                :src="gouActiveImg"
                fit="fill"
                v-if="tabIndex4 === 3 && tabIndex8 === 1"
              />
            </div>
            <div
              :class="{
                'gou-text': true,
                white: tabIndex4 === 3 && tabIndex8 === 1,
              }"
            >
              {{ $t("HomePage.scheme26") }}
            </div>
          </div>
          <div
            :class="{
              'text3-button': true,
              poa40: true,
              'text3-button-active': tabIndex4 === 3 && tabIndex8 === 1,
            }"
            @click="toConsolePage(3)"
          >
            {{ $t("HomePage.scheme14") }}
          </div>
        </div>
      </div>
      <!-- 客服 -->
      <div class="consult">
        <div
          :class="{
            'consult-item1': langName === 'ZH',
            'consult-item1-en': langName === 'EN',
            'consult-item1-tw': langName === 'TW',
          }"
          @click="handleConsult(1)"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        ></div>
        <div
          :class="{
            'consult-item2': langName === 'ZH',
            'consult-item2-en': langName === 'EN',
            'consult-item2-tw': langName === 'TW',
          }"
          @click="handleConsult(2)"
          @mouseenter="handleMouseEnter2"
          @mouseleave="handleMouseLeave2"
        ></div>
      </div>
      <div v-if="isScan" class="scan">
        <el-image :src="scanImgZh" fit="fill" v-if="langName === 'ZH'" />
        <el-image :src="scanWxChat" fit="fill" v-if="langName === 'EN'" />
        <el-image :src="scanWxChatTw" fit="fill" v-if="langName === 'TW'" />
      </div>
      <div v-if="isTel" class="tel">
        <el-image :src="telImgZh" fit="fill" v-if="langName === 'ZH'" />
        <el-image :src="scanWhatApp" fit="fill" v-if="langName === 'EN'" />
        <el-image :src="scanWhatAppTw" fit="fill" v-if="langName === 'TW'" />
      </div>
    </div>
    <div class="fanyi-function">
      <div class="fanyi-function-title">{{ $t("HomePage.fanyi1") }}</div>
      <div class="fanyi-function-subtitle">
        {{ $t("HomePage.fanyi2") }}
      </div>
      <!--  -->
      <div class="fanyi-function-tabs">
        <div
          :class="{
            'fanyi-function-tab-item': true,
            'fanyi-function-tab-item-active': tabIndex5 === 1,
          }"
          @click="handleFanyiTab(1)"
        >
          {{ $t("HomePage.fanyi3") }}
        </div>
        <div
          :class="{
            mlf40: true,
            'fanyi-function-tab-item': true,
            'fanyi-function-tab-item-active': tabIndex5 === 2,
          }"
          @click="handleFanyiTab(2)"
        >
          {{ $t("HomePage.fanyi4") }}
        </div>
        <!-- <div
          :class="{
            'fanyi-function-tab-item': true,
            'fanyi-function-tab-item-active': tabIndex5 === 3,
          }"
          @click="handleFanyiTab(3)"
        >
          {{$t("HomePage.fanyi5")}}
        </div> -->
      </div>
      <div class="fanyi-function-tab-img">
        <el-image
          class="fanyi_image"
          :src="fanyiImg"
          fit="fill"
          v-if="tabIndex5 === 1"
        />
        <el-image
          class="fanyi_image"
          :src="fanyiImg2"
          fit="fill"
          v-if="tabIndex5 === 2"
        />
        <el-image
          class="fanyi_image"
          :src="fanyiImg3"
          fit="fill"
          v-if="tabIndex5 === 3"
        />
      </div>
      <div class="fanyi-function-title">{{ $t("HomePage.fanyi6") }}</div>
      <div class="fanyi-function-subtitle">
        {{ $t("HomePage.fanyi7") }}
      </div>
      <div class="fanyi-function-imgs">
        <div class="fanyi-function-img-item">
          <el-image style="width: 100%" :src="fanyiItemImg1" fit="fill" />
        </div>
        <div class="fanyi-function-img-item mlr60">
          <el-image style="width: 100%" :src="fanyiItemImg2" fit="fill" />
        </div>
        <div class="fanyi-function-img-item">
          <el-image style="width: 100%" :src="fanyiItemImg3" fit="fill" />
        </div>
      </div>
    </div>
    <!-- <div class="intelligent-agent">
      <div class="intelligent-agent-content">
        <div class="intelligent-agent-content-left">
          <div class="text5">{{$t("HomePage.intelligent1")}}</div>
          <div class="text6">
            {{$t("HomePage.intelligent2")}}
          </div>
          <div class="df">
            <div class="intelligent-text1">
              <div>
                <el-image class="icon-img" :src="icon1" fit="fill" />
              </div>
              <div class="icon-text">{{$t("HomePage.intelligent3")}}</div>
            </div>
            <div class="intelligent-text1">
              <div>
                <el-image class="icon-img" :src="icon2" fit="fill" />
              </div>
              <div class="icon-text">{{$t("HomePage.intelligent4")}}</div>
            </div>
          </div>
          <div class="intelligent-button" @click="ask"></div>
        </div>
        <div class="intelligent-agent-content-right" v-if="langName === 'ZH'"></div>
        <div class="intelligent-agent-content-right-en" v-if="langName === 'EN'"></div>
      </div>
    </div> -->
    <div class="support">
      <div class="support-content">
        <div class="support-content-title">{{ $t("HomePage.support1") }}</div>
        <div class="support-contents">
          <div class="support-content-item">
            <div class="df">
              <div>
                <el-image class="icon3-img" :src="icon3" fit="fill" />
              </div>
              <div
                :class="{
                  'icon3-text': true,
                  'icon3-text-en': langName === 'EN',
                }"
              >
                {{ $t("HomePage.support2") }}
              </div>
            </div>
            <div :class="{ text7: true, 'text7-en': langName === 'EN' }">
              {{ $t("HomePage.support3") }}
            </div>
          </div>
          <div class="support-content-item mlr60">
            <div class="df">
              <div>
                <el-image class="icon3-img" :src="icon4" fit="fill" />
              </div>
              <div
                :class="{
                  'icon3-text': true,
                  'icon3-text-en': langName === 'EN',
                }"
              >
                {{ $t("HomePage.support4") }}
              </div>
            </div>
            <div :class="{ text7: true, 'text7-en': langName === 'EN' }">
              {{ $t("HomePage.support5") }}
            </div>
          </div>
          <div class="support-content-item">
            <div class="df">
              <div>
                <el-image class="icon3-img" :src="icon3" fit="fill" />
              </div>
              <div
                :class="{
                  'icon3-text': true,
                  'icon3-text-en': langName === 'EN',
                }"
              >
                {{ $t("HomePage.support6") }}
              </div>
            </div>
            <div :class="{ text7: true, 'text7-en': langName === 'EN' }">
              {{ $t("HomePage.support7") }}
            </div>
          </div>
        </div>
        <!-- 翻译引擎轮播 -->
        <div class="support-footer">
          <el-carousel trigger="click" arrow="never">
            <el-carousel-item>
              <div class="carousel-flex">
                <div>
                  <el-image
                    class="support-footer-img0"
                    :src="openaiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-yandex"
                    :src="yandexImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img1"
                    :src="deeplImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img2"
                    :src="googlefanyiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img3"
                    :src="microsoftImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img4"
                    :src="baidufanyiImg"
                    fit="fill"
                  />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-flex">
                <div>
                  <el-image
                    class="support-footer-img5"
                    :src="youdaoImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-huoshan"
                    :src="huoshanImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img0"
                    :src="openaiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-yandex"
                    :src="yandexImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img1"
                    :src="deeplImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img2"
                    :src="googlefanyiImg"
                    fit="fill"
                  />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-flex">
                <div>
                  <el-image
                    class="support-footer-img0"
                    :src="openaiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-yandex"
                    :src="yandexImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img1"
                    :src="deeplImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img2"
                    :src="googlefanyiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img3"
                    :src="microsoftImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img4"
                    :src="baidufanyiImg"
                    fit="fill"
                  />
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="carousel-flex">
                <div>
                  <el-image
                    class="support-footer-img5"
                    :src="youdaoImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-huoshan"
                    :src="huoshanImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img0"
                    :src="openaiImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img-yandex"
                    :src="yandexImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img1"
                    :src="deeplImg"
                    fit="fill"
                  />
                </div>
                <div>
                  <el-image
                    class="support-footer-img2"
                    :src="googlefanyiImg"
                    fit="fill"
                  />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="footer" ref="targetSection">
      <!-- <el-image class="footer_image" :src="footer" fit="fill" /> -->
      <!-- <div class="footer-title">
        <div style="padding: 24px 0px 42px 0px">
          {{$t("HomePage.footer1")}}
        </div>
        <div class="footer-pop" v-if="footerPop">
          {{$t("HomePage.footer5")}}
        </div>
        <div class="df" style="justify-content: center">
          <div class="names">
            <el-input
              v-model="input1"
              :placeholder="$t("HomePage.footer2")"
              clearable
            ></el-input>
          </div>
          <div class="phone">
            <el-input v-model="input2" :placeholder="$t("HomePage.footer3")" clearable>
              <el-select v-model="select" slot="prepend" placeholder="">
                <el-option label="+86" value="1"></el-option>
                <el-option label="+87" value="2"></el-option>
              </el-select>
            </el-input>
          </div>
        </div>
        <div
          :class="{ reservation: true, scale: isReservation }"
          @click="handleReservation"
        >
          {{$t("HomePage.footer4")}}
        </div>
      </div> -->

      <div class="footer-bottom">
        <div class="footer-bottom-left">
          <div>
            <el-image
              class="footer_logo_image"
              :src="footerLogoImg"
              fit="fill"
            />
          </div>
          <div class="footer_logo_text">
            <div>{{ $t("HomePage.footer6") }}</div>
            <div>{{ $t("HomePage.footer7") }}</div>
            <div>{{ $t("HomePage.footer8") }}</div>
            <div>{{ $t("HomePage.footer9") }}</div>
            <!-- <div>{{ $t("HomePage.footer9") }}</div> -->
          </div>
        </div>
        <!-- <div class="footer-bottom-right">
          <div style="flex: 1; color: #fff">
            <div>{{$t("HomePage.footer10")}}</div>
            <div style="margin: 40px 0px">{{$t("HomePage.footer11")}}</div>
            <div>{{$t("HomePage.footer12")}}</div>
          </div>
          <div style="flex: 1">
            <div>{{$t("HomePage.footer13")}}</div>
            <div style="margin: 40px 0px">{{$t("HomePage.footer14")}}</div>
            <div>{{$t("HomePage.footer15")}}</div>
          </div>
          <div style="flex: 1">
            <div>{{$t("HomePage.footer16")}}</div>
            <div style="margin-top: 105px"></div>
            <div>{{$t("HomePage.footer17")}}</div>
          </div>
        </div> -->
      </div>
      <!-- <div class="beian">{{$t("HomePage.footer18")}}</div> -->
      <div class="beian">
        <span class="cur" @click="handleUserAgreement">{{
          $t("HomePage.text3")
        }}</span>
        <span class="cur m16" @click="handlePrivacyPolicy">{{
          $t("HomePage.text4")
        }}</span>
        <span class="cur" @click="handlePaymentAgreement">{{
          $t("HomePage.text5")
        }}</span>
      </div>
    </div>
    <!-- 用户协议 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible2"
      width="100%"
      :before-close="handleClose2"
      :close-on-click-modal="false"
    >
      <UserAgreement v-if="$i18n.locale === 'cn'"></UserAgreement>
      <UserAgreementEn v-else></UserAgreementEn>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button"
          @click="dialogVisible2 = false"
          >{{ $t("HomePage.text6") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 隐私政策 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible3"
      width="100%"
      :before-close="handleClose3"
      :close-on-click-modal="false"
    >
      <PrivacyPage v-if="$i18n.locale === 'cn'"></PrivacyPage>
      <PrivacyPageEn v-else></PrivacyPageEn>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button"
          @click="dialogVisible3 = false"
          >{{ $t("HomePage.text6") }}</el-button
        >
      </span>
    </el-dialog>
    <!-- 付费协议 -->
    <el-dialog
      top="0px"
      title=""
      :visible.sync="dialogVisible4"
      width="100%"
      :before-close="handleClose4"
      :close-on-click-modal="false"
    >
      <PaidServiceAgreement v-if="$i18n.locale === 'cn'"></PaidServiceAgreement>
      <PaidServiceAgreementEn v-else></PaidServiceAgreementEn>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">{{
          $t("HomePage.text6")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UserAgreement from "@/components/UserAgreement.vue";
import UserAgreementEn from "@/components/UserAgreementEn.vue";
import PrivacyPage from "@/components/PrivacyPage.vue";
import PrivacyPageEn from "@/components/PrivacyPageEn.vue";
import PaidServiceAgreement from "@/components/PaidServiceAgreement.vue";
import PaidServiceAgreementEn from "@/components/PaidServiceAgreementEn.vue";
import { getToken } from "@/utils/auth";
import { productPrices } from "@/api/login/user";
export default {
  name: "HomePage",
  data () {
    return {
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      currency: "",
      textPrices: null,
      consoleIndex: 1,
      personLogoImg: require("@/assets/person-logo.png"),
      isLogin: false,
      account: "",
      showResources: false,
      footerPop: false,
      select: "1",
      langName: "ZH",
      langIndex: 2,
      showLangs: false,
      showConsole: false,
      isReservation: false,
      input1: "",
      input2: "",
      isScan: false,
      isTel: false,
      tabIndex: 1,
      tabIndex2: 1,
      tabIndex3: 0,
      tabIndex4: 1,
      tabIndex5: 1,
      tabIndex6: 2,
      tabIndex7: 2,
      tabIndex8: 1,
      logo: require("@/assets/logo.png"),
      gouImg: require("@/assets/gou.png"),
      gouActiveImg: require("@/assets/gou-active.png"),
      fanyiImg: require("@/assets/beiji4.png"),
      fanyiImgZh: require("@/assets/beiji4.png"),
      fanyiImgEn: require("@/assets/beiji4en.png"),
      fanyiImg2: require("@/assets/beiji5.png"),
      fanyiImg2Zh: require("@/assets/beiji5.png"),
      fanyiImg2En: require("@/assets/beiji5en.png"),
      fanyiImg3: require("@/assets/beiji6.png"),
      fanyiImg3Zh: require("@/assets/beiji6.png"),
      fanyiImg3En: require("@/assets/beiji6en.png"),
      fanyiItemImg1: require("@/assets/fanyi-item-img1.png"),
      fanyiItemImg1Zh: require("@/assets/fanyi-item-img1.png"),
      fanyiItemImg1En: require("@/assets/fanyi-item-img1-en.png"),
      fanyiItemImg2: require("@/assets/fanyi-item-img2.png"),
      fanyiItemImg2Zh: require("@/assets/fanyi-item-img2.png"),
      fanyiItemImg2En: require("@/assets/fanyi-item-img2-en.png"),
      fanyiItemImg3: require("@/assets/fanyi-item-img3.png"),
      fanyiItemImg3Zh: require("@/assets/fanyi-item-img3.png"),
      fanyiItemImg3En: require("@/assets/fanyi-item-img3-en.png"),
      icon1: require("@/assets/icon1.png"),
      icon2: require("@/assets/icon2.png"),
      icon3: require("@/assets/icon3.png"),
      icon4: require("@/assets/icon4.png"),
      footer: require("@/assets/footer.png"),
      deeplImg: require("@/assets/deepl.png"),
      scanWxChat: require("@/assets/scan-wxchat.png"),
      scanWxChatTw: require("@/assets/scan-wxchat-tw.png"),
      scanWhatApp: require("@/assets/scan-whatapp.png"),
      scanWhatAppTw: require("@/assets/scan-whatapp-tw.png"),
      scanImg: require("@/assets/scan1.png"),
      scanImgZh: require("@/assets/scan1.png"),
      scanImgEn: require("@/assets/scan-en.png"),
      telImg: require("@/assets/scan2.png"),
      telImgZh: require("@/assets/scan2.png"),
      telImgEn: require("@/assets/tel-en.png"),
      googlefanyiImg: require("@/assets/googlefanyi.png"),
      microsoftImg: require("@/assets/microsoft.png"),
      baidufanyiImg: require("@/assets/baidufanyi.png"),
      youdaoImg: require("@/assets/youdao.png"),
      openaiImg: require("@/assets/home-openai.png"),
      yandexImg: require("@/assets/home-yandex.png"),
      huoshanImg: require("@/assets/home-huoshan.png"),
      frontMarkImg: require("@/assets/front-mark.png"),
      afterMarkImg: require("@/assets/after-mark.png"),
      freeTrialImg: require("@/assets/free-trial-button.png"),
      freeTrialEnImg: require("@/assets/free-trial-button-en.png"),
      footerLogoImg: require("@/assets/footer-logo.png"),
      appDown1Img: require("@/assets/appDown1.png"),
      appDown2Img: require("@/assets/appDown2.png"),
      appDown3Img: require("@/assets/appDown3.png"),
      imgs: [
        {
          name: "beiji1",
          value: "1",
          imgSrc: require("@/assets/bj.jpg"),
        },
        {
          name: "beiji2",
          value: "2",
          imgSrc: require("@/assets/bj2.jpg"),
        },
      ],
      imgs1: [
        {
          name: "beiji1",
          value: "1",
          imgSrc: require("@/assets/bj.jpg"),
        },
        {
          name: "beiji2",
          value: "2",
          imgSrc: require("@/assets/bj2.jpg"),
        },
      ],
      imgs2: [
        {
          name: "beiji1",
          value: "1",
          imgSrc: require("@/assets/bjtw.jpg"),
        },
        {
          name: "beiji2",
          value: "2",
          imgSrc: require("@/assets/bj2tw.jpg"),
        },
      ],
      imgs3: [
        {
          name: "beiji1",
          value: "1",
          imgSrc: require("@/assets/bjen.jpg"),
        },
        {
          name: "beiji2",
          value: "2",
          imgSrc: require("@/assets/bj2en.jpg"),
        },
      ],
    };
  },
  components: {
    UserAgreement,
    UserAgreementEn,
    PrivacyPage,
    PrivacyPageEn,
    PaidServiceAgreement,
    PaidServiceAgreementEn,
  },
  computed: {
    refreshToken () {
      return this.$store.state.user.refreshToken;
    },
  },
  watch: {},
  mounted () {
    console.log("home---route", this.$route);

    console.log("refreshToken-----", this.refreshToken);
    if (!localStorage.getItem("lang")) {
      this.setLanguage();
    }
    if (localStorage.getItem("acount")) {
      this.account = localStorage.getItem("acount");
      console.log("this.account", this.account);
      const value = getToken();
      if (value) {
        this.isLogin = true;
      }
    }
    this.setImgs();
    this.productPricesNet();
  },
  updated () {
    console.log("updated");

    this.setImgs();
  },
  methods: {
    handleDown (val) {
      if (val === 1) {
        window.open("https://www.xuanjiai.cn/app/download/index.html");
      }
      if (val === 2 || val === 3) {
        window.open("https://www.xuanjiai.cn/app/download/abroad.html");
      }
    },
    handleUserAgreement () {
      this.dialogVisible2 = true;
      this.showLangs = false;
    },
    handlePrivacyPolicy () {
      this.dialogVisible3 = true;
      this.showLangs = false;
    },
    handlePaymentAgreement () {
      this.dialogVisible4 = true;
      this.showLangs = false;
    },
    agree2 () {
      this.dialogVisible4 = false;
    },
    handleOk () {
      this.dialogVisible2 = false;
    },
    handleOk3 () {
      this.dialogVisible3 = false;
    },
    handleClose2 () {
      this.dialogVisible2 = false;
    },
    handleClose3 () {
      this.dialogVisible3 = false;
    },
    handleClose4 () {
      this.dialogVisible4 = false;
    },
    productPricesNet () {
      productPrices().then((res) => {
        console.log("首页文本翻译价格", res);
        if (res?.data) {
          this.textPrices = res.data;
          console.log("this.textPrices", this.textPrices);
        }
      });
    },
    toConsolePage (val) {
      const value = getToken();
      if (value) {
        this.isLogin = true;
      }
      if (!value) {
        this.$message.error(this.$t("TextTranslation.text9"));
        this.$router.replace("/LoginPage");
        return;
      }
      this.$router.push({
        path: "/ConsolePanel",
        query: {
          typeIndex: val
        }
      });
    },
    handleConsoleItem (val) {
      this.consoleIndex = val;
      if (val === 1) {
        console.log("控制台");
        this.$router.push({
          path: "/ConsolePanel",
        });
      }
      if (val === 2) {
        console.log("退出");
        this.$store.dispatch("user/resetToken").then((res) => {
          console.log("res----user/resetToken", res);
        });
        localStorage.removeItem("acount");
        localStorage.removeItem("refreshToken");
        this.$router.push({
          path: "/LoginPage",
        });
      }
    },
    handleConsole () {
      this.showConsole = !this.showConsole;
      this.showLangs = false;
    },
    handleFreeTrial () {
      this.$message.success(this.$t("HomePage.expect"));
    },
    ask () {
      this.$message.success(this.$t("HomePage.expect"));
    },
    setImgs () {
      if (localStorage.getItem("lang") === "cn") {
        this.langName = "ZH";
        this.imgs = this.imgs1;
        this.fanyiImg = this.fanyiImgZh;
        this.fanyiImg2 = this.fanyiImg2Zh;
        this.fanyiImg3 = this.fanyiImg3Zh;
        this.fanyiItemImg1 = this.fanyiItemImg1Zh;
        this.fanyiItemImg2 = this.fanyiItemImg2Zh;
        this.fanyiItemImg3 = this.fanyiItemImg3Zh;
        this.langIndex = 2;
      }
      if (
        localStorage.getItem("lang") === "tw" ||
        localStorage.getItem("lang") === "en"
      ) {
        this.fanyiImg = this.fanyiImgEn;
        this.fanyiImg2 = this.fanyiImg2En;
        this.fanyiImg3 = this.fanyiImg3En;
        this.fanyiItemImg1 = this.fanyiItemImg1En;
        this.fanyiItemImg2 = this.fanyiItemImg2En;
        this.fanyiItemImg3 = this.fanyiItemImg3En;
      }
      if (localStorage.getItem("lang") === "tw") {
        this.langName = "TW";
        this.imgs = this.imgs2;
        this.langIndex = 1;
      }
      if (localStorage.getItem("lang") === "en") {
        this.langName = "EN";
        this.imgs = this.imgs3;
        this.langIndex = 3;
      }
    },
    setLanguage () {
      let language = this.getPreferredLanguage();
      if (language.startsWith("zh")) {
        if (language.startsWith("zh-CN")) {
          localStorage.setItem("lang", "cn");
          this.$i18n.locale = "cn";
          this.langIndex = 2;
          this.imgs = this.imgs1;
          this.fanyiImg = this.fanyiImgZh;
          this.fanyiImg2 = this.fanyiImg2Zh;
          this.fanyiImg3 = this.fanyiImg3Zh;
          this.fanyiItemImg1 = this.fanyiItemImg1Zh;
          this.fanyiItemImg2 = this.fanyiItemImg2Zh;
          this.fanyiItemImg3 = this.fanyiItemImg3Zh;
        }
        if (language.startsWith("zh-TW")) {
          localStorage.setItem("lang", "tw");
          this.$i18n.locale = "tw";
          this.langIndex = 1;
          this.imgs = this.imgs2;
          this.fanyiImg = this.fanyiImgEn;
          this.fanyiImg2 = this.fanyiImg2En;
          this.fanyiImg3 = this.fanyiImg3En;
          this.fanyiItemImg1 = this.fanyiItemImg1En;
          this.fanyiItemImg2 = this.fanyiItemImg2En;
          this.fanyiItemImg3 = this.fanyiItemImg3En;
        }
        return;
      }
      if (language.startsWith("en")) {
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        this.langIndex = 3;
        this.imgs = this.imgs3;
        this.fanyiImg = this.fanyiImgEn;
        this.fanyiImg2 = this.fanyiImg2En;
        this.fanyiImg3 = this.fanyiImg3En;
        this.fanyiItemImg1 = this.fanyiItemImg1En;
        this.fanyiItemImg2 = this.fanyiItemImg2En;
        this.fanyiItemImg3 = this.fanyiItemImg3En;
        return;
      }
    },
    getPreferredLanguage () {
      return navigator.language || navigator.userLanguage;
    },
    handleLangItem (val) {
      this.langIndex = val;
      if (val === 1) {
        this.langName = "TW";
        this.$i18n.locale = "tw";
        localStorage.setItem("lang", "tw");
        localStorage.setItem("acceptLanguage", "zh-TW");
        this.imgs = this.imgs2;
      }
      if (val === 2) {
        this.langName = "ZH";
        this.$i18n.locale = "cn";
        localStorage.setItem("lang", "cn");
        localStorage.setItem("acceptLanguage", "zh-CN");
        this.imgs = this.imgs1;
        this.fanyiImg = this.fanyiImgZh;
        this.fanyiImg2 = this.fanyiImg2Zh;
        this.fanyiImg3 = this.fanyiImg3Zh;
        this.fanyiItemImg1 = this.fanyiItemImg1Zh;
        this.fanyiItemImg2 = this.fanyiItemImg2Zh;
        this.fanyiItemImg3 = this.fanyiItemImg3Zh;
      }
      if (val === 3) {
        this.langName = "EN";
        this.$i18n.locale = "en";
        localStorage.setItem("lang", "en");
        localStorage.setItem("acceptLanguage", "en");
        this.imgs = this.imgs3;
        this.fanyiImg = this.fanyiImgEn;
        this.fanyiImg2 = this.fanyiImg2En;
        this.fanyiImg3 = this.fanyiImg3En;
        this.fanyiItemImg1 = this.fanyiItemImg1En;
        this.fanyiItemImg2 = this.fanyiItemImg2En;
        this.fanyiItemImg3 = this.fanyiItemImg3En;
      }
      this.showLangs = false;
      this.productPricesNet();
      console.log(
        'localStorage.getItem("lang")222',
        localStorage.getItem("lang")
      );
    },
    handleLangs () {
      this.showLangs = !this.showLangs;
      this.showResources = false
    },
    handleMouseEnter () {
      this.isScan = true;
    },
    handleMouseLeave () {
      this.isScan = false;
    },
    handleMouseEnter2 () {
      this.isTel = true;
    },
    handleMouseLeave2 () {
      this.isTel = false;
    },
    toLogin () {
      this.$router.push({
        path: "/LoginPage",
      });
    },
    handleReservation () {
      this.$message.success(this.$t("HomePage.expect"));
      // this.isReservation = true;
      // this.footerPop = true
      // setTimeout(() => {
      //   this.isReservation = false;
      // });
    },
    handleConsult (val) {
      if (val === 1) {
        this.isScan = true;
        this.isTel = false;
      } else {
        this.isTel = true;
        this.isScan = false;
      }
    },
    handleSchemeTabItem (val) {
      this.tabIndex6 = val;
    },
    handleSchemeTabItem2 (val) {
      this.tabIndex7 = val;
    },
    handleSchemeTabItem3 (val) {
      this.tabIndex8 = val;
    },
    handleFanyiTab (val) {
      if (val === 1) {
        this.tabIndex5 = val;
      }
      if (val === 2) {
        this.tabIndex5 = val;
      }
      if (val === 3) {
        this.$message.success(this.$t("HomePage.expect"));
      }
    },
    handleSchemeTab (val) {
      if (val === 1) {
        this.tabIndex4 = val;
        this.tabIndex6 = 2;
      }
      if (val === 2) {
        this.tabIndex4 = val;
        this.tabIndex7 = 2;
        // this.$message.success(this.$t("HomePage.expect"));
      }
      if (val === 3) {
        this.$message.success(this.$t("HomePage.expect"));
      }
    },
    handleCarousel (val) {
      this.tabIndex3 = val;
    },
    handleTabs2 (val) {
      if (val === 1) {
        this.tabIndex2 = 1;
        this.$router.push({
          path: "/APIPage2",
        });
      }
      if (val === 2) {
        this.tabIndex2 = 2;
        this.$router.push({
          path: "/FAQPage",
        });
      }
      if (val === 3) {
        this.tabIndex2 = 3;
        this.showResources = false;
        this.$nextTick(() => {
          const element = this.$refs.targetSection;
          if (element) {
            element.scrollIntoView({ behavior: "smooth" }); // 平滑滚动
          }
        });
      }
    },
    handleTabs (val) {
      this.setImgs();
      this.showLangs = false
      if (val === 1) {
        console.log("首页");
        this.tabIndex = 1;
      }
      if (val === 2) {
        console.log("文本翻译");
        this.tabIndex = 2;
        this.$router.push({
          path: "/TextTranslation",
        });
      }
      if (val === 3) {
        console.log("语音翻译");
        this.tabIndex = 3;
        // this.$message.success(this.$t("HomePage.expect"));
        this.$router.push({
          path: "/VoicePage",
        });
      }
      if (val === 4) {
        console.log("AI智能体");
        this.tabIndex = 4;
        this.$message.success(this.$t("HomePage.expect"));
      }
      if (val === 5) {
        console.log("资源");
        this.tabIndex = 5;
        // this.$message.success(this.$t("HomePage.expect"));
        this.showResources = !this.showResources;
      }
    },
  },
};
</script>
